import { string, object, array } from "yup"

const schema = object().shape({
  name: string().required(),
  permissionsIds: array().of(string()),
})

export default schema
